import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';

import {
  CasEditForm,
  CasRHFColorField,
  CasRHFTextField,
  CasRHFSwitch,
  IEditForm,
} from 'src/compass/shared/components';
import { CasTagChip } from 'src/compass/application';

import { TagSchema } from '../schema/TagSchema';

// The tag as it will look on a customer, following the Tag and Color fields as they change.
function TagPreview() {
  const { control } = useFormContext();
  const [name, color] = useWatch({ control, name: ['name', 'color'] });

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="body2" color="text.secondary">
        Preview:
      </Typography>
      <CasTagChip tag={{ name: name || 'Tag', color }} />
    </Stack>
  );
}

export default function TagForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};

  const defaultValues = useMemo(
    () => (id ? row : { name: '', isActive: true, color: null }),
    [id, row]
  );

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity="Tag"
      schema={TagSchema}
    >
      <CasRHFTextField name="name" label="Tag" />
      <CasRHFColorField
        name="color"
        label="Color"
        helperText="Leave blank for the default color"
      />
      <TagPreview />
      <CasRHFSwitch name="isActive" label="Active" />
    </CasEditForm>
  );
}
